import React from 'react';

export function BillingModalLead({ children }) {
  return <p className="billing-modal-lead">{children}</p>;
}

export function BillingModalSection({ title, children, highlight = false }) {
  return (
    <div className={`billing-modal-section${highlight ? ' billing-modal-section--highlight' : ''}`}>
      {title ? <div className="billing-modal-section__title">{title}</div> : null}
      <div className="billing-modal-section__body">{children}</div>
    </div>
  );
}

export function BillingModalFactList({ items }) {
  return (
    <dl className="billing-modal-facts">
      {items.map(({ label, value }) => (
        <div key={label} className="billing-modal-facts__row">
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function BillingModalNotes({ children }) {
  return <div className="billing-modal-notes">{children}</div>;
}

export function BillingModalNote({ children }) {
  return <p className="billing-modal-note">{children}</p>;
}
